import PROGRESS_TYPES from './progress/types';
import DISTRIBUTE_BALANCE_TYPES from './distribute-balance/types';

export default {
  ...PROGRESS_TYPES,
  ...DISTRIBUTE_BALANCE_TYPES,
};
